var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"groups"},[_c('vue-headful',{attrs:{"title":_vm._f("formatTitle")(_vm.$t('TITLE_TYPE', { type: _vm.$tc('GROUP', 2) }))}}),_vm._v(" "),_c('group-list'),_vm._v(" "),_c('router-view',{staticClass:"groups__route"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }